import { render, staticRenderFns } from "./ServiceSystem.vue?vue&type=template&id=010b6ef2&scoped=true&"
import script from "./ServiceSystem.vue?vue&type=script&lang=js&"
export * from "./ServiceSystem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSystem.vue?vue&type=style&index=0&id=010b6ef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b6ef2",
  null
  
)

export default component.exports